import store from "@/lib/store";

// Bound to the user id so a cache entry can't be read back after a different user logs in
// in the same tab.
export function getOptionsCacheKey(criteria) {
  const userId = store.getters["auth/user"]?.id ?? null;

  return JSON.stringify({ userId, criteria });
}
